// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-26f95a1e]{list-style:none;list-style-type:none}.promo-grid[data-v-26f95a1e]{justify-content:center}@media (min-width:775px){.promo-grid[data-v-26f95a1e]{justify-content:flex-start}}.promo-grid-slide[data-v-26f95a1e]{max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
